import _ from 'lodash';
import { getSales, updateProductStock } from '../../apis/backend';
import { ERROR_UPDATE_STOCK, ERROR_GET_SALES } from '../../constants';


export const handleCheckBox = (component, checked) => {
  component.setState({ ...component.state, checked });
};
export const handleClick = (
  { vente, name, stockRestant, productId, sectionId, revenue },
  component
) => {
  component.setState({
    modalOpen: true,
    name,
    vente,
    stockRestant,
    productId,
    sectionId,
    revenue,
    checked: !Number.isInteger(parseInt(stockRestant, 10))
  });
};

export const handleClose = component => {
  component.setState({ modalOpen: false });
};

export const handleChange = ({ target }, component) =>
  component.setState({ [target.id]: parseInt(target.value, 10), checked: false });

export const handleSubmit = async component => {
  const { productId, sectionId, checked } = component.state;
  const { openErrorModal, shopId } = component.props;
  let { stockRestant } = component.state;
  if (!checked) {
    stockRestant = stockRestant > 0 ? stockRestant : 0;
  } else {
    stockRestant = null;
  }
  try {
    await updateProductStock(sectionId, productId, { stock: stockRestant })
  } catch (err) {
    openErrorModal(ERROR_UPDATE_STOCK);
  }
  component.setState({ modalOpen: false });
};

export const initStock = async (props, component, disableLoading) => {
  const { menu, shopId, openErrorModal } = props;
  try {
    !disableLoading &&
      component.setState({
        isLoading: true,
        stock: []
      });
    const { dateRange } = component.state;
    const startAt = dateRange.startDate;
    const endAt = dateRange.endDate;
    const sales = (await getSales(shopId, startAt, endAt)) || {};
    const productStock = {};
    if (menu.sections) {
      _.map(menu.sections, (section, sectionId) => {
        const { products = {}, key: sectionKey } = section;
        _.map(products, (product, productId) => {
          const { name = '', stock, key: productKey } = product;
          const productRef = `${sectionKey}@${productKey}`;
          let sold = 0;
          let price = 0;
          _.map(sales, sale => {
            const saleProduct = _.find(sale.products, product => {
              return product.productRef === productRef;
            });
            if (saleProduct) {
              sold += saleProduct.nb;
              price += saleProduct.revenue;
            }
          });
          productStock[productKey] = {
            productId,
            sectionId,
            sold,
            price,
            name,
            stock
          };
        });
      });
      const filteredProductStock = _.pickBy(productStock, (product) => {
        return product.sold > 0 || product.price > 0;
      });
      component.setState({
        stock: _.sortBy(filteredProductStock, ['price']).reverse(),
        isLoading: false
      });
    }
  } catch (error) {
    openErrorModal(ERROR_GET_SALES);
    component.setState({
      isLoading: false,
      stock: []
    });
  }
};

export const onSelectDate = async (component, dateRange) => {
  await component.setState({
    dateRange,
    isLoading: true,
    stock: []
  });
  initStock(component.props, component);
};
